module.exports = __webpack_public_path__ + "img/icon_5_90.b3baef50.png";